import React, { useState, useEffect } from "react";
import Molecule from "../../../MComponent/Molecule";
import { getFiles, getFullDateFromEpoch, getDateFromEpoch } from "../../../Utils/Common/Library";
import mappings from "./data";
import DownloadReport from "./DownloadReport";
import AlertMessage from "../../../Utils/Messages/AlertMessage";

const { Table } = Molecule;
const heading = ["File Name", "Date", "Download"];

const reportTypes = ["PT", "PS", "APT", "APS","AR","PWC"];

function ReportsTable({ type, isAppraiser }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const init = async () => {
    try {
      const promises = [getFiles({ queryName: mappings[type], isAppraiser })];
      if (reportTypes.includes(type)) {
        promises.push(getFiles({ queryName: mappings["All" + type], isAppraiser }));
      }
      const [res1, res2] = await Promise.all(promises);
      let list = [];
      if (res1?.success === "1" && res1?.data) {
        list = res1.data;
      }

      if (res2?.success === "1" && res2?.data?.length) {
        list = [...list, ...res2.data];
      }
      console.log("List: ", list);

      list = list.sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified)).slice(0, 5);
      setRows(
        list.map(({ fileName, lastModified, url }) => [
          <div style={{ maxWidth: 300 }}>{fileName}</div>,
          getFullDateFromEpoch({ epoch: new Date(lastModified).getTime(), time: true }),
          <DownloadReport url={url} fileName={fileName} onError={(err) => setError(err)} />,
        ])
      );
    } catch (e) {
      console.log(e);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    init();
    // getFiles({ queryName: mappings[type], isAppraiser })
    //   .then((res) => {
    //     let rows = [];
    //     if (res?.success === "1" && res?.data) {
    //       rows = res.data.map(({ fileName, lastModified, url }) => [
    //         <div style={{ maxWidth: 300 }}>{fileName}</div>,
    //         getFullDateFromEpoch({
    //           epoch: new Date(lastModified).getTime(),
    //           time: true,
    //         }),
    //         <DownloadReport url={url} fileName={fileName} onError={(err) => setError(err)} />,
    //       ]);
    //     }
    //     if (reportTypes.includes(type)) {
    //       getFiles({ queryName: mappings["All" + type], isAppraiser })
    //         .then((allRes) => {
    //           if (allRes?.success === "1" && allRes?.data) {
    //           }
    //         })
    //         .catch((e) => {
    //           setError(true);
    //           console.log(e);
    //         });
    //     }
    //   })
    //   .catch((e) => {
    //     setError(true);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  }, []);
  if (loading) return <>Fetching Files...</>;
  if (error)
    return <AlertMessage type={1} message={"Network Error"} onClose={() => setError(false)} />;
  if (!type || rows.length === 0) return <>No reports</>;
  return (
    <div>
      <Table heading={heading} rows={rows} removeSearch={true} />
    </div>
  );
}

export default ReportsTable;
